import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { getInsurerCopyDetail, getInsurerDetail } from '@/services/admin/insurers';

export const useInsurerDetail = (id: number) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['insurerDetail', currentSite, id],
    queryFn: () => getInsurerDetail(currentSite, id),
    select: res => res.data,
    enabled: !!id,
    staleTime: 0,
    gcTime: 0,
  });
};

export const useInsurerCopyDetail = (id: number) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['insurerCopyDetail', currentSite, id],
    queryFn: () => getInsurerCopyDetail(currentSite, id),
    select: res => res.data,
    enabled: !!id,
    staleTime: 0,
    gcTime: 0,
  });
};
